import * as React from "react";
import { isActiveCareCoordinator } from "intake_shared/src/assignment";
import { AclContext } from "../../../contexts/AclContext";
import { PageHeader } from "../bits/PageHeader/PageHeader";
import TimeOffCard from "./TimeOffCard";
import styles from "./TimeOff.module.scss";

export default function MyTimeOff() {
    const context = React.useContext(AclContext);
    const account = context?.authUser;
    const email = account?.user?.email;
    const canManageOwn =
        isActiveCareCoordinator(account) ||
        (account?.acl?.super_admin === true &&
            !account.deleted &&
            !account.acl.blocked);
    return (
        <div className={`v2-page ${styles.page}`}>
            <PageHeader title="My time off" />
            {email && canManageOwn && <TimeOffCard email={email} />}
        </div>
    );
}
